import React from "react";
import { isCompanyRegistrationApprovalEnabled } from "../config/featureFlags.ts";
import RegisterCompanyApproval from "./RegisterCompanyApproval.tsx";
import RegisterLegacy from "./RegisterLegacy.tsx";

export { generateRegistrationPassword } from "./RegisterLegacy.tsx";

// Com a flag desligada, o cadastro segue exatamente o fluxo atual (PF ou PJ, conta criada na hora).
const Register: React.FC = () =>
  isCompanyRegistrationApprovalEnabled() ? <RegisterCompanyApproval /> : <RegisterLegacy />;

export default Register;
